import React from "react";
import ReportUtils from "../../../../../utils/report-utils.js";

const DatesContent = ({dates, isUpdate = false}) => {
    if (!dates) return null;

    const list = Array.isArray(dates) ? dates : [];
    if (!list.length) return null;

    const rows = list.flatMap((dateObj, index) =>
        Object.entries(dateObj).map(([key, value], i) => {

            if (isUpdate) {
                return (
                    <tr key={`${index}-${i}`} className="text-left">
                        <td>{key}</td>
                        <td>{ReportUtils.formatObjectString(value?.new)}</td>
                        <td>{ReportUtils.formatObjectString(value?.old)}</td>
                    </tr>
                );
            }

            return (
                <tr key={`${index}-${i}`} className="text-left">
                    <td>{key}</td>
                    <td>{ReportUtils.formatObjectString(value)}</td>
                </tr>
            );
        })
    );

    return (
        <>
            <tr className={"text-left"}>
                <th colSpan={isUpdate ? 3 : 2}>Datas</th>
            </tr>
            {rows}
        </>
    );
};

export default DatesContent;